module.exports = __webpack_public_path__ + "static/media/thinker.53ef3464.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/thinker.svg
// module id = 41
// module chunks = 0